import { get, post } from "../../../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getKpiIndicators = (documentId, siteId) =>
  get(`${url}/LeasingFacilities/${documentId}/${siteId}/getFacilityKpiIndicators`);

const saveKpiIndicators = (documentId, siteId, kpiIndicators) =>
  post(`${url}/LeasingFacilities/${documentId}/${siteId}/saveKpiIndicators`, {
    documentId,
    siteId,
    kpiIndicators
  });

const exp = {
  getKpiIndicators,
  saveKpiIndicators
};
export default exp;
